var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-5"},[_c('h1',[_vm._v("ERROR 404")]),_c('h2',[_vm._v("URL not found")])])
}]

export { render, staticRenderFns }